import { useSearchParams } from 'react-router-dom'
import { PageShell } from '../components/PageShell'
import { PageTabs } from '../components/PageTabs'
import { CareerTabContent } from '../panels/CareerTab'
import { GoalsTabContent, AchievementsTabContent } from '../panels/PlaceholderTabs'
import { Briefcase, Target, Medal, History } from 'lucide-react'

const TAB_KEYS = ['trayectoria', 'metas', 'logros'] as const

// The manager's story — trajectory, the full goals panel (the Dashboard shows a
// compact teaser of it) and achievements.
export function CareerPage() {
  // Reward shortcuts deep-link here with ?tab=metas[&goal=id]; the tab is
  // URL-driven so those links also work while already on this page.
  const [params, setParams] = useSearchParams()
  const active = Math.max(0, TAB_KEYS.indexOf(params.get('tab') as (typeof TAB_KEYS)[number]))
  const handleTabChange = (i: number) => {
    setParams(
      (p) => {
        p.set('tab', TAB_KEYS[i] ?? TAB_KEYS[0])
        p.delete('goal')
        return p
      },
      { replace: true },
    )
  }

  return (
    <PageShell
      pageId="career"
      title="Carrera"
      subtitle="Tu trayectoria como mánager"
      icon={<Briefcase size={22} />}
    >
      <PageTabs
        variant="broadcast"
        activeTab={active}
        onTabChange={handleTabChange}
        tabs={[
          {
            label: 'Trayectoria',
            icon: <History size={16} />,
            content: <CareerTabContent />,
          },
          {
            label: 'Metas',
            icon: <Target size={16} />,
            content: <GoalsTabContent />,
          },
          {
            label: 'Logros',
            icon: <Medal size={16} />,
            content: <AchievementsTabContent />,
          },
        ]}
      />
    </PageShell>
  )
}
